import React, { Component } from 'react';

import Css from './Mobile.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NavItem from './NavItem/NavItem';

import { Link } from 'react-router-dom';
import LetsConnectMobile from '@components/LetsConnectMobile/LetsConnectMobile';
import ImportImages from '@src/importImages';

const Logo = ImportImages('/logo.png');

class Mobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        {
          id: 100,
          title: 'Who We Are',
          dropdown: false,
          url: '/',
          goto: 1
        },
        {
          id: 101,
          title: 'Why JetSuite',
          dropdown: false,
          url: '/',
          goto: 2
        },
        {
          id: 1,
          title: 'How To Fly',
          dropdown: true,
          expanded: false,
          childs: [
            {
              title: 'SuiteKey Membership',
              url: '/suitekey-membership'
            },
            {
              title: 'Charter',
              url: '/charter'
            },
            {
              title: 'Wholesale',
              url: '/wholesale'
            }
          ]
        },
        {
          id: 2,
          title: 'Aircraft',
          dropdown: true,
          expanded: false,
          childs: [
            {
              title: 'Aircraft',
              url: '/our-aircraft'
            },
            {
              title: 'Compare Aircraft',
              url: '/compare-aircraft'
            },
            {
              title: 'Safety',
              url: '/safety'
            }
          ]
        },
        {
          id: 105,
          title: 'Experiences',
          dropdown: false,
          url: '/jetsuite-experiences'
        },
        {
          id: 3,
          title: 'Login',
          dropdown: false,
          url: '/quoting'
        },
        {
          id: '3-auth',
          title: 'My Account',
          dropdown: true,
          expanded: false,
          childs: [
            {
              title: 'My Account',
              url: '/quoting'
            },
            {
              title: 'Log Out',
              url: '#',
              click: props.logoutAction,
              external: true
            }
          ]
        },
        {
          id: 4,
          title: 'Subscribe',
          dropdown: false,
          url: '/subscribe'
        },
        {
          id: 5,
          title: 'Careers',
          dropdown: false,
          url: '/careers'
        },
        {
          id: 6,
          title: 'In The News',
          dropdown: false,
          url: '/news'
        },
        {
          id: 7,
          title: 'FAQ',
          dropdown: false,
          url: '/faq'
        },
        {
          id: 8,
          title: 'JetSuiteX',
          dropdown: false,
          url: 'https://www.jetsuitex.com',
          external: true
        },
        {
          id: 9,
          title: 'Leadership',
          dropdown: false,
          url: '/leadership'
        },
        {
          id: 10,
          title: 'Legal',
          dropdown: false,
          url: '/legal'
        }
      ],
      showMenu: false
    };
  }

  toggleMenu = () => {
    const showMenu = this.state.showMenu;
    this.setState({
      showMenu: !showMenu
    });
  };

  toggleDropdown = itemId => {
    const updated = this.state.navItems.map(
      (content, i) =>
        content.id === itemId
          ? { ...content, expanded: !content.expanded }
          : content
    );
    this.setState({
      navItems: updated
    });
  };

  render() {
    const menuClass = this.state.showMenu ? ' ' : ' d-none';
    return (
      <React.Fragment>
        <header
          className={
            Css.header +
            ' d-flex align-items-center justify-content-center pl-3 pr-3'
          }
        >
          <Link to={'/'} className={'nav-anhor'} data-goto={0}>
            <img src={Logo} className={'img-fluid '} alt={'JetSuite Logo'} />
          </Link>
          {!this.props.hideNav && (
            <button
              className={Css['nav-btn']}
              onClick={() => this.toggleMenu()}
            >
              {this.state.showMenu ? (
                <FontAwesomeIcon icon={['fas', 'times']} />
              ) : (
                <FontAwesomeIcon icon={['fas', 'bars']} />
              )}
            </button>
          )}

          <div className={Css['nav-container'] + menuClass}>
            <div className={Css.body + ' scrollable'}>
              <nav>
                <ul>
                  {this.state.navItems.map(item => {
                    if (
                      (item.id !== 3 && item.id !== '3-auth') ||
                      (item.id === 3 && !this.props.isAuthenticated) ||
                      (item.id === '3-auth' && this.props.isAuthenticated)
                    ) {
                      return (
                        <NavItem
                          {...item}
                          click={() => this.toggleDropdown(item.id)}
                          toggle={() => this.toggleMenu()}
                          key={item.id}
                        />
                      );
                    }
                    return null;
                  })}
                </ul>
              </nav>
            </div>
          </div>
        </header>
        {!this.props.isAuthenticated && <LetsConnectMobile />}
      </React.Fragment>
    );
  }
}

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/Header/Mobile/Mobile.js